export default {
  information: {
    button: 'Information',
    title: 'How to import leave requests',
    download: 'Download example (.xlsx)',
    prepare:
      'Select the company and download the example workbook. Keep the leave sheet name, column order and first 3 rows. Copy the fictitious example to row 4 onward and replace it with your data. Set id to a number for each data row (1, 2, 3, ...). Rows whose id is example or instructions are skipped. Do not leave blank rows between records.',
    format:
      'Store start and end as text in YYYY-MM-DD format and start_time and end_time as text in HH:mm format (for example, 08:30 and 10:30). Enter both times for hourly leave, including the correct end date for overnight leave. Times may be blank for day or half-day leave.',
    values:
      'employee_code must belong to the selected company. type is the leave type ID configured for that company; ask your administrator for the correct ID. time_unit: 1 = full day, 2 = morning half-day, 3 = afternoon half-day, 4 = hours. Set emergent and block to true or false and enter the reason.',
    upload:
      'Save the prepared workbook as .xlsx and click Upload after the company has loaded. Wait while the file is queued and processed.',
    result:
      'Click Refresh to retrieve the latest result. Check the employee code, status and error details for each row. Only the latest import result is shown. Refresh stays disabled until an import job is available. Correct failed rows and upload only those rows again to avoid duplicating successful requests.'
  },
  form: {
    'import-leave-file': 'Upload File (.csv , .xlsx)',
    title: {
      'import-leave': 'Leave Day Employee Document Management'
    }
  },
  'import-table': {
    row: 'Row',
    empCode: 'Employee Code',
    detail: 'Detail',
    status: 'Status'
  }
}
